import { render, staticRenderFns } from "./DealerFooter.vue?vue&type=template&id=1bfdffc6&scoped=true"
import script from "./DealerFooter.vue?vue&type=script&lang=js"
export * from "./DealerFooter.vue?vue&type=script&lang=js"
import style0 from "./DealerFooter.vue?vue&type=style&index=0&id=1bfdffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfdffc6",
  null
  
)

export default component.exports